import { render, staticRenderFns } from "./serviceOrderModule.vue?vue&type=template&id=52eb8dd6&scoped=true&"
import script from "./serviceOrderModule.vue?vue&type=script&lang=ts&"
export * from "./serviceOrderModule.vue?vue&type=script&lang=ts&"
import style0 from "./serviceOrderModule.vue?vue&type=style&index=0&id=52eb8dd6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52eb8dd6",
  null
  
)

export default component.exports